import type { CityConfig } from "@/pages/city-template/types";

export const sherwoodConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Oregon Vital Records (Birth, Death, Marriage)", desc: "Request certified birth, death, and marriage certificates from Oregon Vital Records.", url: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/Pages/index.aspx" },
    { icon: "ri-government-line", label: "Washington County Clerk Vital Records", desc: "Obtain vital records through the Washington County Clerk's office.", url: "https://www.washingtoncountyor.gov/CountyClerk" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", desc: "Official online ordering partner of Oregon Vital Records for certified certificates.", url: "https://www.vitalchek.com/" },
  ],
  city: "Sherwood",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "sherwood",
  route: "/cities/sherwood",
  title: "Emergency Passport Sherwood, OR | Fast Passport Renewal & Expedited Services",
  metaDescription: "Emergency passport and expedited passport services in Sherwood, OR — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Sherwood and Washington County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Sherwood, Oregon",
  heroSubtitle: "Planning a family trip to Mexico or Europe from PDX? Passport expired before your big adventure? Fast Passport Center helps Sherwood and Washington County families get passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Sherwood%20Oregon%20charming%20suburban%20neighborhood%20with%20tree-lined%20streets%2C%20well-maintained%20family%20homes%20with%20lush%20Pacific%20Northwest%20gardens%2C%20Mount%20Hood%20visible%20on%20the%20horizon%20at%20golden%20hour%2C%20warm%20amber%20sunlight%20casting%20long%20shadows%2C%20peaceful%20affluent%20suburb%20atmosphere%2C%20photorealistic%20landscape%20photography%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=sherwood-or-hero-01&orientation=landscape",
  heroImageAlt: "Sherwood Oregon charming suburban neighborhood with tree-lined streets and Mount Hood views",
  geoPosition: "45.3551;-122.8395",
  geoPlacename: "Sherwood, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 175 miles north — 3 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Sherwood", zips: "97140" },
    { name: "Tualatin", zips: "97062" },
    { name: "Tigard", zips: "97223, 97224" },
    { name: "Newberg", zips: "97132" },
    { name: "Wilsonville", zips: "97070" },
    { name: "Beaverton", zips: "97003–97008" },
    { name: "Lake Oswego", zips: "97034–97035" },
    { name: "Hillsboro", zips: "97123, 97124" },
    { name: "Forest Grove", zips: "97116" },
    { name: "Portland", zips: "97201–97299" },
    { name: "West Linn", zips: "97068" },
    { name: "Durham", zips: "97224" },
    { name: "King City", zips: "97224" },
    { name: "Dundee", zips: "97115" },
    { name: "Aloha", zips: "97007, 97078" },
    { name: "Raleigh Hills", zips: "97225" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Sherwood home in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Sherwood", desc: "FedEx and UPS locations in Sherwood and nearby Tualatin and Tigard offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission — critical for family travel with children's passports and multiple applicants." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport agency — no hunting for public appointments." },
  ],
  testimonials: [
    {
      name: "Amanda C.",
      location: "Sherwood, OR",
      rating: 5,
      text: "Family vacation to Mexico — realized our son's child passport was expired 3 weeks before our trip. Fast Passport Center was amazing. They walked us through the child passport process step by step and we had it in 8 days. Sherwood families, use this service.",
      service: "Child Passport",
    },
    {
      name: "Brian T.",
      location: "Sherwood, OR",
      rating: 5,
      text: "Passport renewal for a cruise to Alaska. Shipped from the Tualatin FedEx on Monday and had my renewed passport by Friday. Five days total. Ridiculous how fast and easy this was.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia R.",
      location: "Tualatin, OR",
      rating: 5,
      text: "My passport was damaged from a beach vacation — pages were water damaged. Fast Passport Center handled the replacement in 7 days. Sherwood and Tualatin residents, stop going to the post office and use this service instead.",
      service: "Damaged Passport",
    },
  ],
  facilities: [
    {
      id: "sherwood-post",
      name: "Sherwood Post Office",
      type: "USPS Passport Acceptance",
      address: "14895 SW Sherwood Blvd",
      city: "Sherwood",
      state: "OR",
      zip: "97140",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Sherwood — primary location",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Sherwood. Appointment required — book online in advance. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "tualatin-post",
      name: "Tualatin Post Office",
      type: "USPS Passport Acceptance",
      address: "19250 SW Martinazzi Ave",
      city: "Tualatin",
      state: "OR",
      zip: "97062",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Tualatin — about 3 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Tualatin option — often has better appointment availability than Sherwood.",
      icon: "ri-mail-line",
    },
    {
      id: "tigard-post",
      name: "Tigard Post Office",
      type: "USPS Passport Acceptance",
      address: "13635 SW Pacific Hwy",
      city: "Tigard",
      state: "OR",
      zip: "97223",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm, Sat 9am–12pm",
      distance: "Tigard — about 5 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Tigard option for northeast Sherwood and King City residents.",
      icon: "ri-mail-line",
    },
    {
      id: "newberg-post",
      name: "Newberg Post Office",
      type: "USPS Passport Acceptance",
      address: "401 E 1st St",
      city: "Newberg",
      state: "OR",
      zip: "97132",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Newberg — about 8 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Newberg option for south Sherwood and Yamhill County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "beaverton-post",
      name: "Beaverton Post Office",
      type: "USPS Passport Acceptance",
      address: "4200 SW Watson Ave",
      city: "Beaverton",
      state: "OR",
      zip: "97005",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm, Sat 9am–12pm",
      distance: "Beaverton — about 9 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Beaverton option for north Sherwood and Washington County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "lake-oswego-post",
      name: "Lake Oswego Post Office",
      type: "USPS Passport Acceptance",
      address: "4000 Kruse Way Pl",
      city: "Lake Oswego",
      state: "OR",
      zip: "97035",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Lake Oswego — about 7 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Lake Oswego option for east Sherwood and affluent Portland suburb residents.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Sherwood before international family travel?",
      a: "Yes. Through Fast Passport Center, Sherwood travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on eligibility and travel documentation. Family travel passport emergencies are one of our most common requests from Sherwood. Start online today.",
    },
    {
      q: "How fast can I renew my passport in Sherwood?",
      a: "Fast passport renewal in Sherwood is available through Fast Passport Center in as little as 3 business days with our expedited service, or 3–5 weeks with our standard expedited option. Renewal applications are eligible if your current passport was issued at age 16 or older and within the last 15 years. No office visit required for most renewals.",
    },
    {
      q: "How do I expedite a child passport in Sherwood?",
      a: "Child passports in Sherwood (for minors 15 and under) require an in-person acceptance appointment with parental consent — both parents typically need to be present or provide notarized consent. Fast Passport Center provides a clear checklist, helps you select the best acceptance facility, and handles expedited processing once the acceptance step is complete.",
    },
    {
      q: "Can I get a same-day passport appointment near Sherwood?",
      a: "Same-day passport appointments at the regional passport agency in Seattle are only available for documented life-or-death emergencies and are not guaranteed. For most urgent passport situations near Sherwood, Fast Passport Center is the faster and more predictable option — no three-hour Seattle drive required.",
    },
    {
      q: "What if my entire family needs passports renewed at the same time?",
      a: "Multi-family passport renewals are common from Sherwood. Fast Passport Center can handle multiple applications at once. Children under 16 will require in-person acceptance appointments, while adults can typically renew by mail. Contact us and we'll coordinate your family's timeline to meet your travel date.",
    },
    {
      q: "What should I do if I lost my passport before a trip?",
      a: "If your passport is lost or stolen before an upcoming trip, act immediately. You will need to complete Form DS-64 to report it and apply for a replacement. Fast Passport Center guides you through this process and can expedite your replacement. Don't delay — lost passport replacements require extra steps.",
    },
    {
      q: "Does Sherwood have a passport agency?",
      a: "Sherwood, Oregon does not have a regional passport agency. The closest regional agencies are the Seattle Passport Agency in Washington (about 175 miles north) and the San Francisco Passport Agency in California (about 650 miles south). Both require appointments and proof of travel within 14 days. Fast Passport Center is the faster, more convenient solution.",
    },
    {
      q: "How long does a standard passport take in Sherwood?",
      a: "Standard USPS passport processing from Sherwood runs 6–13 weeks — sometimes longer during peak travel season. If your trip is sooner, you need expedited processing. Fast Passport Center offers Sherwood travelers processing as fast as 24 hours.",
    },
    {
      q: "Can I renew my passport in Sherwood without visiting a passport office?",
      a: "Yes. Most Sherwood adults renewing a passport can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center, complete your documents at home, and ship them overnight from any FedEx or UPS location in Sherwood or Tualatin.",
    },
    {
      q: "What airports do Sherwood travelers fly from?",
      a: "Sherwood travelers primarily use Portland International Airport (PDX) — about 20 miles northeast — for all domestic and international departures. PDX offers direct flights to Amsterdam, London, Reykjavik, Tokyo, Vancouver, and more. Fast Passport Center can help you meet any PDX departure deadline.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Sherwood", address: "16050 SW Langer Dr, Sherwood, OR 97140", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Sherwood", address: "14895 SW Sherwood Blvd, Sherwood, OR 97140", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Tualatin", address: "19015 SW Tualatin Valley Hwy, Tualatin, OR 97062", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 8 AM – 8 PM" },
    { name: "The UPS Store — Tualatin", address: "19238 SW Martinazzi Ave, Tualatin, OR 97062", hours: "Mon–Fri 8 AM – 7 PM" },
    { name: "Walgreens — Tualatin", address: "19405 SW Tualatin Valley Hwy, Tualatin, OR 97062", hours: "Daily 8 AM – 10 PM" },
    { name: "Walmart — Sherwood", address: "15995 SW Tualatin-Sherwood Rd, Sherwood, OR 97140", hours: "Daily 7 AM – 11 PM" },
    { name: "FedEx Office — Tigard", address: "12180 SW Scholls Ferry Rd, Tigard, OR 97223", hours: "Mon–Fri 7 AM – 10 PM" },
    { name: "CVS — Tigard", address: "14000 SW Pacific Hwy, Tigard, OR 97224", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Beaverton", address: "12640 SW Broadway, Beaverton, OR 97005", hours: "Daily 8 AM – 10 PM" },
    { name: "Costco — Beaverton", address: "12055 SW Canyon Rd, Beaverton, OR 97005", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Tigard DMV Office",
      address: "8900 SW Commercial St, Tigard, OR 97223",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Closest DMV to Sherwood. Washington County. Driver licenses, REAL ID, ID cards. Appointment recommended.",
      featured: true,
    },
    {
      name: "Beaverton DMV Office",
      address: "4200 SW Watson Ave, Beaverton, OR 97005",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Beaverton option for north Sherwood residents.",
      featured: false,
    },
    {
      name: "Newberg DMV Office",
      address: "610 E 1st St, Newberg, OR 97132",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Yamhill County option for south Sherwood residents heading into wine country.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Primary international airport — about 20 miles northeast",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "PDX offers direct international flights to Amsterdam, London, Reykjavik, Tokyo, Vancouver, and more. The busiest travel seasons are May–August and December–January — plan passport needs well in advance for summer family travel.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "Alternative hub — about 175 miles north",
      address: "17801 International Blvd, SeaTac, WA 98158",
      note: "Some Sherwood travelers use SEA for additional flight options. Passport required for all international departures.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying from PDX in 24–72 hours? Our emergency courier service handles urgent last-minute travel from Sherwood and Washington County — including family passport emergencies.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Sherwood families and professionals renew fast — perfect for family vacations to Mexico, cruises, and international trips from PDX.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Sherwood", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Sherwood travelers through Form DS-64 and the replacement process — urgent timelines available.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passport expedited service for Sherwood families — minors under 16 require in-person acceptance and parental consent. We provide clear instructions and checklists for the whole family.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Sherwood residents — we guide you through the acceptance clerk process and handle expedited processing.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Passport Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — we submit through reserved agency channels, not the public line. Same-day passport help for Sherwood travelers.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports for frequent travelers — all handled with expedited courier access.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Sherwood, Oregon travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Sherwood residents needing passports faster than standard government mail timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Sherwood, OR residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement service for Sherwood travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Sherwood families with minors under 16." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport submission service serving Sherwood, Oregon." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long for Family Passport Applications", description: "Sherwood families often discover multiple expired passports when booking summer trips. Government processing runs 6–13+ weeks. Apply the moment you book — for children's passports especially, start at least 3 months ahead." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores often get rejected for lighting, background, or expression issues. For children's photos especially, strict requirements apply. We provide exact specifications for every family member." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application is returned and you lose weeks. Our pre-submission checklist catches errors before your Sherwood family trip becomes a nightmare." },
    { icon: "ri-pen-nib-line", title: "Missing Child Consent Documentation", description: "Child passports require both parents to consent — or a notarized statement from the absent parent. Forgetting this documentation is the #1 reason child passport applications are rejected. We provide a complete checklist." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Sherwood runs 6–13 weeks. If your family trip is in under 10 weeks, standard processing is not a safe option. Use Fast Passport Center instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Between Passport and Airline Ticket", description: "Your passport name must match your airline ticket exactly — for every family member. Middle names, hyphens, and suffixes cause more rejections than you'd expect, especially on family bookings." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Sherwood travel date. Complete your secure order online — takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We confirm your details and send you a personalized document checklist — exactly what you need for each family member, nothing more." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Sherwood", description: "Drop off at any FedEx or UPS in Sherwood or Tualatin — most locations are open evenings. No office visit to our facility required." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through our reserved passport agency slots — bypassing the public appointment system entirely." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to you. No guessing, no hoping." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots, often weeks out in Seattle", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (3 hours each way)", fpc: "Ship documents overnight from Sherwood" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable", fpc: "Predictable processing based on option selected" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Portland", route: "/cities/portland" },
    { name: "Fast passport renewal in Tualatin", route: "/cities/tualatin" },
    { name: "Emergency passport help near Tigard", route: "/cities/tigard" },
    { name: "Rush passport service in Newberg", route: "/cities/newberg" },
    { name: "Fast passport renewal for Washington County travelers", route: "/states/oregon" },
  ],
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Sherwood or Tualatin — most are open evenings. No office visit to our facility required for most services.",
  fpcOfficeDistance: "Serving Sherwood and all of Washington County remotely",
  serviceAreaIntro: "Whether you are in Sherwood, Tualatin, King City, or anywhere in the Washington County south metro, Fast Passport Center makes expedited passport processing simple — start online, ship overnight, and we handle the rest.",
  nearbyCitiesIntro: "We serve all Sherwood and Washington County south zip codes. Anywhere in the Tualatin Valley corridor — ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Sherwood as simple as possible. Most Sherwood clients never visit an office.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Sherwood families. We review your documents before submission to catch issues before they become problems.",
  testimonialsIntro: "Real reviews from Sherwood, Tualatin, and Washington County travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions Sherwood and Washington County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
};